module.exports = __webpack_public_path__ + "static/blog-cover-f55e924eff608d71da37e57b398c587d.jpg";